export default "__VITE_ASSET__B6vfO5h1__"